import {cast, Instance, SnapshotOut, types} from "mobx-state-tree"
import {StaffModel, StaffSnapshot} from "../staff/staff";
import {StaffFirestore} from "../../services/firestore/staff-firestore";

/**
 * Example store containing Rick and Morty characters
 */
export const StaffStoreModel = types
    .model("StaffStore")
    .props({
        staff: types.maybe(types.array(StaffModel)),
        isLoadingStaff: types.optional(types.boolean, false)
    })
    .actions((self) => ({
        saveStaff: async (data: StaffSnapshot[]) => {
            self.staff = cast(data)
            self.isLoadingStaff = false
        },
    }))
    .actions((self) => ({
        getStaff: async (businessId: string) => {
            self.isLoadingStaff = true
            const staffFirestore = new StaffFirestore()
            const result = await staffFirestore.getStaff(businessId)

            if (result.kind === "ok" && result.data !== undefined) {
                self.saveStaff(result.data)
                return result.data
            } else {
                console.log(result.kind)
                self.isLoadingStaff = false
                return null
            }
        },
        refreshStaff: async (businessId: string) => {
            const staffFirestore = new StaffFirestore()
            const result = await staffFirestore.getStaff(businessId)

            if (result.kind === "ok" && result.data !== undefined) {
                self.saveStaff(result.data)
            }
        },
    }))
    .actions((self) => ({
        addStaff: async (formData: {
            name: string,
            email: string,
            role: string,
            projectIds: string[]
        }, businessId) => {
            const staffFirestore = new StaffFirestore()
            const result = await staffFirestore.addStaff(formData, businessId)

            if (result.kind === "ok") {
                await self.refreshStaff(businessId)
                return true
            } else {
                console.log(result.kind)
                return false
            }
        },
        updateStaff: async (id, formData: {
            name: string,
            role: string,
            projectIds: string[]
        }, businessId) => {
            const staffFirestore = new StaffFirestore()
            const result = await staffFirestore.updateStaff(id, formData)

            if (result.kind === "ok") {
                await self.refreshStaff(businessId)
                return true
            } else {
                console.log(result.kind)
                return false
            }
        },
        deleteStaff: async (id, businessId) => {
            const staffFirestore = new StaffFirestore()
            const result = await staffFirestore.deleteStaff(id)

            if (result.kind === "ok") {
                await self.refreshStaff(businessId)
                return true
            } else {
                console.log(result.kind)
                return false
            }
        },

    }))

type StaffStoreType = Instance<typeof StaffStoreModel>

export interface StaffStore extends StaffStoreType {
}

type StaffStoreSnapshotType = SnapshotOut<typeof StaffStoreModel>

export interface StaffStoreSnapshot extends StaffStoreSnapshotType {
}

export const createStaffStoreDefaultModel = () => types.optional(StaffStoreModel, {})
